// extracted by mini-css-extract-plugin
module.exports = {"doubleCol":"DoubleColumn-module--doubleCol--3a24_"};